/** @format */
import React from 'react';
import GridItem from '../../../components/Grid/GridItem';
import GridContainer from '../../../components/Grid/GridContainer';
import InputFormRest from '../../../components/Form/InputFormRest';
import { DiscountEntity } from '../PlatformResellerDiscount/PlatformResellerDiscount';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import CheckBoxSimple from '../../../components/Form/CheckBoxSimple';
import { Moment } from 'moment';
import { SimpleSelect } from '../../../components/Adescom/SimpleSelect';
import { DiscountHelper } from '../../../helpers/DiscountHelper';
import PaymentForDiscountTable from './PaymentForDiscountTable';
import FractionSelection from './FractionSelection';
import PrefixSelection from './PrefixSelection';
import PrefixInterface from '../../../interfaces/billing/PrefixInterface';
import CustomDatePicker from '../../../components/Form/CustomDatePicker';
import { DateHelper } from '../../../helpers/DateHelper';

interface DiscountFormProps {
    entity: DiscountEntity;
    setEntity: (entity: DiscountEntity) => void;
    entityStatus: any;
    setEntityStatus: (entityStatus: any) => void;
    payments: Array<{ date: Moment | string; amount: number }>;
    setPayments: (payments: Array<{ date: Moment | string; amount: number }>) => void;
}

const DiscountForm = (props: DiscountFormProps): React.ReactElement => {
    const { entity, setEntity, entityStatus, setEntityStatus } = props;
    const updateCallback = (
        event: React.FormEvent<HTMLInputElement>,
        stateName: string,
        typeField: string,
        typeCallback: string,
        required: boolean,
        vMax: number,
        vMin?: number
    ): void => {
        const tmp = { ...entity };
        FormGeneralHelper.validateFormsHook(tmp, setEntity, entityStatus, setEntityStatus, event, stateName, typeField, required, vMax, vMin);
    };

    const selectCallback = (e: React.ChangeEvent<HTMLSelectElement>): void => {
        setEntity({ ...entity, [e.target.name]: e.target.value });
    };

    const getSelectedFractions = (fractions: Array<{ id: number; mainname: string }>): void => {
        let ids = fractions.map((el: { id: number; mainname: string }) => el.id);
        const idsAsStr = ids.join(',');
        setEntity({ ...entity, destination: idsAsStr });
    };
    const getSelectedPrefixes = (prefixes: Array<PrefixInterface>): void => {
        let pref = prefixes.map((el: PrefixInterface) => el.prefix);
        const prefAsStr = pref.join(',');
        setEntity({ ...entity, destination: prefAsStr });
    };

    return (
        <GridContainer spacing={1}>
            <GridItem xs={6}>
                <InputFormRest
                    stateName={'name'}
                    displayFieldName={'discount:h.name'}
                    value={entity.name}
                    stateObjectState={entityStatus.name}
                    typeCallback={FormGeneralHelper.TYPE_TEXT}
                    typeField={FormGeneralHelper.TYPE_TEXT}
                    callback={updateCallback}
                    required={true}
                    vMin={1}
                    vMax={255}
                />
            </GridItem>
            <GridItem xs={3}>
                <InputFormRest
                    stateName={'priority'}
                    displayFieldName={'discount:h.priority'}
                    value={entity.priority}
                    stateObjectState={entityStatus.priority}
                    typeCallback={FormGeneralHelper.TYPE_NUMBER}
                    typeField={FormGeneralHelper.TYPE_NUMBER}
                    callback={updateCallback}
                    required={true}
                    vMin={1}
                    vMax={255}
                />
            </GridItem>
            <GridItem xs={3}>
                <CheckBoxSimple
                    checked={entity.useAllResellerNumbers}
                    disabled={entity.allowUseOnProduct > 0}
                    label={'discount:h.include_operator_contracts'}
                    callback={(param: boolean): void => setEntity({ ...entity, useAllResellerNumbers: param })}
                />
            </GridItem>
            <GridItem xs={3}>
                <CheckBoxSimple
                    checked={entity.active}
                    label={'discount:h.active'}
                    callback={(param: boolean): void => setEntity({ ...entity, active: param })}
                />
            </GridItem>
            {/*<GridItem xs={3}>*/}
            {/*    <CheckBoxSimple*/}
            {/*        checked={entity.onlyThisPromo}*/}
            {/*        label={'discount:h.only_this_promo'}*/}
            {/*        callback={(param: boolean): void => setEntity({...entity, onlyThisPromo: param})}*/}
            {/*    />*/}
            {/*</GridItem>*/}
            {/*{entity.type !== DiscountHelper.VALUE_TYPE.TYPE_PROPORTIONATE && (*/}
            <GridItem xs={3}>
                <CheckBoxSimple
                    checked={entity.oneTime}
                    label={'discount:h.single'}
                    callback={(param: boolean): void => setEntity({ ...entity, oneTime: param })}
                />
            </GridItem>
            {/*)}*/}
            <GridItem xs={3}>
                <CheckBoxSimple
                    checked={entity.allowUseOnProduct > 0}
                    disabled={entity.useAllResellerNumbers}
                    label={'discount:h.allow_use_on_product'}
                    callback={(param: boolean): void => setEntity({ ...entity, allowUseOnProduct: param ? 1 : -1 })}
                />
            </GridItem>
            <GridItem xs={3}>
                <CheckBoxSimple
                    checked={entity.propOnFirstMonth === true}
                    label={'discount:h.prop_on_first_month'}
                    callback={(param: boolean): void => setEntity({ ...entity, propOnFirstMonth: param ? true : null })}
                />
            </GridItem>
            {entity.allowUseOnProduct === 1 && (
                <React.Fragment>
                    <GridItem xs={9} />
                    <GridItem xs={3}>
                        <InputFormRest
                            stateName={'customPrefix'}
                            displayFieldName={'discount:h.custom_prefix'}
                            value={entity.customPrefix}
                            stateObjectState={entityStatus.customPrefix}
                            typeCallback={FormGeneralHelper.TYPE_TEXT}
                            typeField={FormGeneralHelper.TYPE_TEXT}
                            callback={updateCallback}
                            required={false}
                            vMin={1}
                            vMax={255}
                        />
                    </GridItem>
                </React.Fragment>
            )}
            <GridItem xs={6}>
                <CustomDatePicker
                    helpText={'discount:h.date_start'}
                    fieldName={'dateStart'}
                    callback={(moment: Moment | string): void => setEntity({ ...entity, dateStart: moment })}
                    placeholder={'DD-MM-YYYY'}
                    dateFormat={'DD-MM-YYYY'}
                    autoComplete={'off'}
                    defaultValue={entity.dateStart}
                />
            </GridItem>
            <GridItem xs={6}>
                <CustomDatePicker
                    helpText={'discount:h.date_end'}
                    fieldName={'dateEnd'}
                    callback={(moment: Moment | string): void => setEntity({ ...entity, dateEnd: moment })}
                    dateFormat={'DD-MM-YYYY'}
                    placeholder={'DD-MM-YYYY'}
                    autoComplete={'off'}
                    defaultValue={entity.dateEnd}
                />
            </GridItem>
            <GridItem xs={6}>
                <div>
                    <CustomDatePicker
                        helpText={'discount:h.grace_period'}
                        fieldName={'gracePeriod'}
                        callback={(moment: Moment | string): void => setEntity({ ...entity, gracePeriod: moment })}
                        dateFormat={'DD-MM-YYYY'}
                        placeholder={'DD-MM-YYYY'}
                        autoComplete={'off'}
                        defaultValue={entity.gracePeriod}
                    />
                </div>
            </GridItem>
            <GridItem xs={6}>
                <InputFormRest
                    stateName={'historyLength'}
                    displayFieldName={'discount:h.history_length'}
                    value={entity.historyLength}
                    stateObjectState={entityStatus.historyLength}
                    typeCallback={FormGeneralHelper.TYPE_NUMBER}
                    typeField={FormGeneralHelper.TYPE_NUMBER}
                    callback={updateCallback}
                    required={false}
                    vMin={1}
                    vMax={255}
                />
            </GridItem>
            <GridItem xs={6}>
                <div>
                    <SimpleSelect
                        label={'discount:h.type'}
                        required={true}
                        elements={DiscountHelper.getValueType()}
                        dispatchName={'type'}
                        selectedValue={entity.type}
                        fieldName={'type'}
                        callback={selectCallback}
                    />
                </div>
            </GridItem>
            <GridItem xs={6}>
                <InputFormRest
                    stateName={'count'}
                    displayFieldName={'discount:h.value'}
                    value={entity.count}
                    stateObjectState={entityStatus.count}
                    typeCallback={FormGeneralHelper.TYPE_NUMBER}
                    typeField={FormGeneralHelper.TYPE_NUMBER}
                    callback={updateCallback}
                    required={true}
                    vMin={1}
                    vMax={255}
                />
            </GridItem>
            {entity.type === DiscountHelper.VALUE_TYPE.TYPE_FREE_MINUTES && (
                <GridItem xs={12}>
                    <CheckBoxSimple
                        checked={entity.skipInitialPrice}
                        label={'discount:h.skip_initial_price'}
                        callback={(param: boolean): void => setEntity({ ...entity, skipInitialPrice: param })}
                    />
                </GridItem>
            )}
            {/*<GridItem xs={4}>*/}
            {/*    <CheckBoxSimple*/}
            {/*        checked={entity.firstMonthOnly}*/}
            {/*        label={'discount:h.first_month_only'}*/}
            {/*        callback={(param: boolean): void => setEntity({...entity, firstMonthOnly: param})}*/}
            {/*    />*/}
            {/*</GridItem>*/}
            {/*<GridItem xs={4}>*/}
            {/*    <CheckBoxSimple*/}
            {/*        checked={entity.payment}*/}
            {/*        label={'discount:h.payment'}*/}
            {/*        callback={(param: boolean): void => setEntity({...entity, payment: param})}*/}
            {/*    />*/}
            {/*</GridItem>*/}
            {entity.payment && (
                <GridItem xs={12}>
                    <PaymentForDiscountTable payments={props.payments} setPayments={props.setPayments} />
                </GridItem>
            )}
            <GridItem xs={12}>
                <GridContainer>
                    <GridItem xs={4}>
                        <SimpleSelect
                            label={'discount:h.filter_type'}
                            fieldName={'filterType'}
                            required={true}
                            elements={DiscountHelper.getDestinationType()}
                            dispatchName={'filterType'}
                            selectedValue={entity.filterType}
                            callback={selectCallback}
                        />
                    </GridItem>
                </GridContainer>
            </GridItem>
            <GridItem xs={12}>
                {entity.filterType === DiscountHelper.DESTINATION.DESTINATION_FRACTIONS && (
                    <FractionSelection getSelectedFractions={getSelectedFractions} entity={entity} />
                )}
                {entity.filterType === DiscountHelper.DESTINATION.DESTINATION_PREFIXES && (
                    <PrefixSelection getSelectedPrefixes={getSelectedPrefixes} entity={entity} />
                )}
            </GridItem>
        </GridContainer>
    );
};

export default DiscountForm;
